<template>
    <div
        class="tab-container"
    >
        <div class="header-content">
            <h1 class="tab-header">
                <div>{{ title }}</div>
            </h1>
            <div class="tab-description text-block">
                {{ description }}
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    }
};
</script>

<style src="./common.tab.css" scoped></style>
<style lang="postcss" scoped>
div.tab-container {
    @apply pt-0 pb-32;
}
div.header-content {
    @apply top-0 bg-white w-full pt-8;
}
</style>
